var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslate } from 'react-admin';
import { styled } from '@mui/material/styles';
export var FormDialogTitle = function (props) {
    var translate = useTranslate();
    var defaultTitle = props.defaultTitle, onClose = props.onClose, record = props.record, title = props.title;
    return (_jsxs(StyledDialogTitle, { id: "edit-dialog-title", children: [title === undefined
                ? defaultTitle
                : typeof title === 'string'
                    ? translate(title, __assign({ _: title }, record))
                    : title, _jsx(IconButton, { "aria-label": translate('ra.action.close'), className: FormDialogTitleClasses.closeButton, onClick: onClose, children: _jsx(CloseIcon, {}) })] }));
};
var PREFIX = 'RaFormDialogTitle';
export var FormDialogTitleClasses = {
    closeButton: "".concat(PREFIX, "-closeButton"),
};
var StyledDialogTitle = styled(DialogTitle, {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(FormDialogTitleClasses.closeButton)] = {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
        _b);
});
